import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Collapsible from 'Douleutaras/components/Collapsible/Collapsible';
import useIsHydrated from 'Douleutaras/hooks/useIsHydrated';
// import infoIcon from 'Assets/layout/profile/services-info.svg';

import ServiceRow from './ServiceRow';
// import ServiceInfoModal from './ServiceInfoModal';
import { CatalogueCategory } from './types';
import './ServiceCategoryRow.scss';

interface ServiceCategoryRowProps {
  category: CatalogueCategory;
  /** Initial expand state. Defaults to collapsed (perf: sub2 render deferred until open). */
  defaultExpanded?: boolean;
  /** Invoked when a child service row is clicked — routes into the post-job (booking) flow. */
  onServiceClick?(): void;
}

/**
 * A collapsible category built on the reusable {@link Collapsible}: tinted header with the
 * category label, a collapse chevron, and a ⓘ button (opens the info modal shell). Owns the
 * modal state; the expand/collapse state lives inside `Collapsible`.
 *
 * The category itself is NOT a booking target — only its child service rows are. Child rows
 * (sub1 + sub2) are only mounted while expanded, since `Collapsible` defers its body.
 */
export const ServiceCategoryRow = ({ category, defaultExpanded = false, onServiceClick }: ServiceCategoryRowProps) => {
  const { t } = useTranslation();
  // const [infoOpen, setInfoOpen] = useState(false);
  const hydrated = useIsHydrated();
  const [expanded, setExpanded] = useState(defaultExpanded);
  // Server-render (and the matching first client render) expanded, so the priced service rows
  // land in the crawlable HTML; after hydration fall back to the interactive default.
  const isExpanded = hydrated ? expanded : true;

  // const infoButton = (
  //   <button
  //     type="button"
  //     styleName="service-category__info"
  //     aria-label={t('T.PROS-PROFILE.SERVICES.INFO-ARIA')}
  //     onClick={() => setInfoOpen(true)}
  //   >
  //     <img src={infoIcon} alt="" aria-hidden="true" styleName="service-category__info-icon" />
  //   </button>
  // );

  return (
    <li styleName="service-category">
      <Collapsible
        id={`service-category-${category.categoryId}`}
        title={category.label}
        // headerActions={infoButton}
        expanded={isExpanded}
        onToggle={setExpanded}
      >
        <ul styleName="service-category__services">
          {category.services.map(service => (
            <ServiceRow key={service.serviceId} service={service} onServiceClick={onServiceClick} />
          ))}
        </ul>
      </Collapsible>

      {/*<ServiceInfoModal*/}
      {/*  isOpen={infoOpen}*/}
      {/*  categoryLabel={category.label}*/}
      {/*  onClose={() => setInfoOpen(false)}*/}
      {/*/>*/}
    </li>
  );
};

export default ServiceCategoryRow;
